export const callInfogram = (targetWindow) => {
  if (!targetWindow.document.getElementById('infogram-async')) {
    const script = targetWindow.document.createElement('script');
    script.id = 'infogram-async';
    script.src = 'https://e.infogram.com/js/dist/embed-loader-min.js';
    targetWindow.document.head.append(script);
  }
  targetWindow.InfogramEmbeds?.process();
};
